export const ADD_RESERVATION_CART_COUPON_REQUEST =
  'ADD_RESERVATION_CART_COUPON_REQUEST';
export const GET_RESERVATION_CART_REQUEST = 'GET_RESERVATION_CART_REQUEST';
export const GET_RESERVATION_CART_OBJECT_REQUESTING =
  'GET_RESERVATION_CART_OBJECT_REQUESTING';
export const GET_RESERVATION_CART_SUCCESS = 'GET_RESERVATION_CART_SUCCESS';
export const UPDATE_RESERVATION_CART_REQUEST =
  'UPDATE_RESERVATION_CART_REQUEST';
export const RESET_RESERVATION_CART_ISFETCHING =
  'RESET_RESERVATION_CART_ISFETCHING';
export const PROCESS_RESERVATION_CART_REQUEST =
  'PROCESS_RESERVATION_CART_REQUEST';
export const PROCESS_PAY_STACK_RESERVATION_CART_UP_REQUEST =
  'PROCESS_PAY_STACK_RESERVATION_CART_UP_REQUEST';
export const CREATE_RESERVATION_CART_REQUEST =
  'CREATE_RESERVATION_CART_REQUEST';
export const MOBILE_RESERVATION_CART_SUMMARY_VISIBLE =
  'MOBILE_RESERVATION_CART_SUMMARY_VISIBLE';
export const MOBILE_RESERVATION_CART_SUMMARY_NOT_VISIBLE =
  'MOBILE_RESERVATION_CART_SUMMARY_NOT_VISIBLE';
export const CREATE_RESERVATION_CART_CUSTOMER_AND_SETUP_INTENT_REQUEST =
  'CREATE_RESERVATION_CART_CUSTOMER_AND_SETUP_INTENT_REQUEST';
